import React, { useEffect, useState } from "react";
import { AsyncSelect } from "@atlaskit/select";
import apiClient from "../../api/admin-api-client";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

function SelectWorkflow({ onChange, value, isDisabled }) {
    const { t } = useTranslation();
    const [options, setOptions] = useState([]);
    const [pending, setPending] = useState(true);
    useEffect(() => {
        search()
            .then(opt => {
                setOptions(opt);
                setPending(false);
            });
    }, []);

    const search = () => apiClient("workflows")
        .then(response => {
            return Promise.resolve(response?.data?.map(i => ({
                label: i.id + " - " + i.name,
                value: i.id,
            })));
        })
        .catch(() => Promise.resolve([]));

    const selected = options?.find(i => i?.value === value);

    return <Wrapper>
        <AsyncSelect 
            defaultOptions={options} 
            value={selected} 
            onChange={onChange} 
            isDisabled={isDisabled || pending} 
            placeholder={t("admin_select_workflow_placeholder")} />
    </Wrapper>;
}

export default SelectWorkflow;

const Wrapper = styled.div`

`;